<template>
  <div class="animated fadeIn">
    <b-breadcrumb><strong>Upload BOM File</strong></b-breadcrumb>

    <b-row>
      <!----- SideBar All Design List ---->
      <!-- <sidebarSettingsComponent></sidebarSettingsComponent> -->
      <!----- SideBar All Design List End ---->

      <div class="design-container-details__main">
        <div class="col-md-12 ">
          <!-- code for table -->
          <b-row>
            <b-col md="12">
              <b-card-body>

                <b-row class="m-5">
                    <b-col md="2" class="mt-2">
                         <label ><b>Select Brand</b></label>
                    </b-col>
                    <b-col md="4">
                        <b-form-select @change="selectbrand()"
                            id="select_brandId"
                            class="form-control"
                            name="select_brandId"
                            placeholder="Please Select Brand."
                            v-validate="'required'"
                            v-model="select_brandId"
                            :class="{
                            input: true,
                            'text-danger': errors.has(
                                'brandselectform.select_brandId'
                            ),
                            }"
                        >
                            <option :value="null">--Select--</option>
                            <option
                            :value="brand_list.brand_id"
                            v-for="brand_list in brand_item"
                            >{{ brand_list.brand_title }}</option
                            >
                        </b-form-select>
                
                    </b-col>
                    <b-table
                        class="m-4"
                        caption-top
                        show-empty
                        stacked="md"
                        :items="bomfile_data"
                        :fields="fields3"
                        :current-page="currentPage"
                        :perPage="perPage"
                        :bordered="bordered"
                        :filter="filter"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :sort-direction="sortDirection"
                        @filtered="onFiltered"
                    >
                        <!-- <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                        </div> -->
                        <template slot="ID" slot-scope="row">
                            {{ getRowIndex(row) }}
                        </template>

                        <template slot="filepath" slot-scope="row">
                        
                          <a :href="row.item.file_path" download>
                            <button><i class="fa fa-download" aria-hidden="true"></i></button>
                        </a>
                        </template> 

                        <template slot="action" slot-scope="row">
                        <button v-if="row.item.is_active == 'Yes'" @click="activebom(row.item.id, 'No')" class="btn" style="background-color:#4DBD74 !important;"> Active
                        </button>
                        <button v-if="row.item.is_active == 'No'" @click="activebom(row.item.id, 'Yes')" class="btn" style="background-color:#F86C6B !important;"> In Active
                        </button>
                        </template>
                    </b-table>

                    <b-col md="6" class="my-1" v-if="this.totalRows > 0">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="my-0"
                        ></b-pagination>
                    </b-col>


                    <b-col >
                        <button style="float:right" class="btn btn-primary mr-2" @click="addNewBomModal()" v-if="this.select_brandId">Add New BOM</button>
                    </b-col>

                    </b-row>

                    </b-card-body>
                    </b-col>
                </b-row>

                <!-- Delete style Modal -->
                <b-modal title="Delete Style" v-model="showAddNewBomModal" @ok="showAddNewBomModal = false" size="xs" @hide="clearVariables">
                    
                    <form @submit.prevent="validateUpdatedBomFile()">
                        <div class="d-flex align-items-center">
                            <b-form-group class="flex-grow-1 mr-2 mt-3">
                            <b-form-file
                                v-model="file1"
                                :state="Boolean(file1)"
                                placeholder="Upload BOM File"
                                accept=".xlsx"
                                @change="AddSampleimage($event)"

                                required
                            ></b-form-file>
                            </b-form-group>
                            <button class="btn btn-success ">Add New BOM</button>
                        </div>
                    </form>
                </b-modal>

                <!-- Close Delete modal -->
        </div>
      </div>



    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import auth from "@/utils/auth";
import Vue from "vue";
import Utils from "@/utils";
import { ToggleButton } from "vue-js-toggle-button";

Vue.component("ToggleButton", ToggleButton);
// import auth from "@/utils/auth";

import sidebarSettingsComponent from "./_sidebarSettingsComponent.vue";
import Table from "../views/base/Table.vue";

const axios = require("axios");
export default {
  name: "Tabs",
  components: {
    sidebarSettingsComponent,
    Table,

  },
  data() {
    return {
        brand_item: [],
        totalRows:0,
        result: [],
        select_brandId:null,
        bomfile_data:[],
        currentPage: 1,
        perPage: 6,
        fields3: [
        { key: "ID", lable: "ID"},
        { key: "file_name", label: "File Name"},
        { key: "filepath", label: "Download"},
        { key: "action", label: "Action"},
        ],
        bomstatus:[],
        showAddNewBomModal: false,
        currentUploadFile:'',
        file1:'',
    };
  },

    created: function() {
        this.getselecteduserbrand()
  },

  methods: {

       //Code For Select Brand
    getselecteduserbrand: function(value) {
      this.isBusy = true;
      var userData = localStorage.getItem("userData");
      var userInfo = userData ? JSON.parse(userData) : null;
      const Obj = {
        user_id: userInfo[0].user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getAllocateddBrandList`, Obj)
        .then((response) => {
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.brand_item = this.result.returnvalue;
            console.log("PPPPPPPPPPPPPPPPPP", this.brand_item);

       
          } else {
            this.brand_item = [];

          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    // select_brandId
    selectbrand(){
    document.getElementById("overlay").style.display = "block";
        // alert(this.select_brandId)
    const Obj = {
        brand_id: this.select_brandId, 
      };
      axios
        .post(`${CONSTANTS.API_URL}/getBOMList`, Obj)
        .then((response) => {
            document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.bomfile_data = this.result.returnvalue;
            console.log(this.bomfile_data,"bomfile_data")
            this.totalRows = this.result.returnvalue.length;
       
          } else {
            this.bomfile_data = [];
            this.totalRows = 0;

          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    activebom(id, value){   
        document.getElementById("overlay").style.display = "block";
        const Obj = {
        BomId: id,
        isActive: value
      };
      axios
        .post(`${CONSTANTS.API_URL}/updateBOMIsActive`, Obj)
        .then((response) => {
            document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.bomstatus = this.result.returnvalue;
            console.log(this.bomstatus)
             this.$fire({
                text: "BOM File Updated Successfully",
                type: "success",
                timer: 30000,
              });
            this.selectbrand();
       
          } else {
            this.bomstatus = [];
         

          }
        })
        .catch((e) => {
          this.errors.push(e);
        });

    },

    addNewBomModal(){
    // alert(this.select_brandId)
    this.showAddNewBomModal = true
    
    },

    AddSampleimage(event) {
        const file = event.target.files[0]; // Assuming you're handling file input change event
        this.currentUploadFile = file
       
    },

    validateUpdatedBomFile(){
        document.getElementById("overlay").style.display = "block";
        if(this.file1 != '' || this.file1 != null)
        {
            // brand_id: this.brand_id,
            let data = new FormData();
            data.append("file", this.currentUploadFile);
            data.append("brand_id", this.select_brandId);
            
            let config = {
                header: {
                    "Content-Type": "multipart/form-data",
                },
            };
            console.log(data); 
            axios
            .post(`${CONSTANTS.API_URL}/uploadBOMXSLXManually`, data)
            .then((response) => {
            console.log("BBBBBBBBBBBBBBBBBBBB", response)
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            if(this.result.returnmsg == 'Successful'){
                this.$fire({
                    text: "BOM File Uploaded Successfully",
                    type: "success",
                    timer: 30000,
                });
                this.showAddNewBomModal = false
            }
            else if(this.result.returnmsg == 'UnSuccessful'){
                  this.$fire({
                        text: this.result.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                this.showAddNewBomModal = false
            }
            this.selectbrand()
            
            })
        }
       
       
    },

     clearVariables() {
        // Clear the variable here
        this.file1 = null;
    },

     getRowIndex(row) {
      // Calculate the index based on the current page and items per page
      return (this.currentPage - 1) * this.perPage + row.index + 1;
    },


    }
};
</script>
